export class ApproversRoleID {
  public static Contractor = 1;
  public static AuthorSupervision = 4;
  public static Customer = 5;
  public static OperatingOrganization = 6;
  public static PTOEngeneer = 7;
  public static ASEngeneer = 8;
  public static DevelopersRepresentative = 9; // Представитель Застройщика
}